import React from 'react';
import RewardPoints from '../features/rewardPoints/rewardPoints';

const RewardPointsPage = () => {
  return <RewardPoints />;
};

export default RewardPointsPage;
